import React, {Component, Fragment} from 'react'
import PropTypes from "prop-types";
import {CircularProgress, Grid, LinearProgress, Typography, withStyles} from "@material-ui/core";
import AuctionCont from "./AuctionCont";
import PBNInfoCont from "./PBNInfoCont"
import {PlayerEastComp, PlayerNorthComp, PlayerSouthComp, PlayerWestComp} from "./PlayerCont";
import PBNResultCont from "./PBNResultCont"
import PlayControlCont from "./PlayControlCont"
import TalonCont from "./TalonCont"
import {nextAuction, previousAuction, resetAuction, showAuction} from "../actions";
import {connect} from "react-redux";
import {Title} from "@material-ui/icons";
import PBNPlayingInfoCont from "./PBNPlayinInfoCont";

const style = theme => ({
    wrapper: {
        height: '100%',
        minHeight: '0px',
        position: 'relative'
    },
    emptyContainer: {
        position: 'absolute',
        height: '100%',
        minHeight: '0px',
        top: '0',
        left: '0'
    },
    container: {
        height: '100%',
        minHeight: '0px',
    },
    auctionContainer: {
        [theme.breakpoints.down('sm')]: {
            height: '40%',
        },
        [theme.breakpoints.up('sm')]: {
            height: '100%',
        },
        minHeight: '0px'
    },
    playContainer: {
        [theme.breakpoints.down('sm')]: {
            height: '60%',
        },
        [theme.breakpoints.up('sm')]: {
            height: '100%',
        },
        minHeight: '0px'
    }

});

class PBNViewerContent extends Component {

    render() {
        const {classes} = this.props;

        if (!this.props.loaded) {
            return (
                <div className={classes.wrapper}>
                    <Grid item container className={classes.emptyContainer} justify={"center"} alignContent={"center"}>
                        <Typography variant={"headline"}>There is no loaded hand!</Typography>
                    </Grid>
                    <LinearProgress hidden={!this.props.fetching} />
                </div>
            );
        }

        return (
            <Grid item container className={classes.container} spacing={8} sm={12} xs={12} direction={"row"}>
                <Grid item className={classes.auctionContainer} container wrap={"nowrap"} direction={"column"} sm={3} xs={12}>
                    <AuctionCont/>
                </Grid>
                <Grid item className={classes.playContainer} container wrap={"nowrap"} direction={"column"} sm={9} xs={12} >
                    <Grid item container spacing={0} xs={12} direction={"row"} alignContent={"space-between"} justify={"center"}>
                        <Grid item xs={4}>
                            <PBNInfoCont/>
                        </Grid>
                        <Grid item xs={4}>
                            <PlayerNorthComp />
                        </Grid>
                        <Grid item xs={4}>
                            <PBNResultCont />
                        </Grid>
                        <Grid item xs={4}>
                            <PlayerWestComp />
                        </Grid>
                        <Grid item xs={4}>
                            <TalonCont />
                        </Grid>
                        <Grid item xs={4}>
                            <PlayerEastComp/>
                        </Grid>
                        <Grid item xs={4}>
                            <PBNPlayingInfoCont/>
                        </Grid>
                        <Grid item xs={4}>
                            <PlayerSouthComp />
                        </Grid>
                        <Grid item xs={4}>
                            <PlayControlCont/>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

PBNViewerContent.propTypes = {
    classes: PropTypes.object,
    fetching: PropTypes.bool,
    loaded: PropTypes.bool
}

function mapStateToProps(state, ownProps){
    return {
        fetching: state.pbnRequest.isFetching,
        loaded: (state.pbnData.pbnGamesTextArray.length != 0)
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
    };
}

export default withStyles(style)(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(PBNViewerContent)
);